import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import { readAccessToken, writeAccessToken } from './utils/accessToken';
import {
  CurrentUserApiResource,
  GuestApiResource,
  ManagerApiResource,
  VendorApiResource,
} from '@/api';

const useUsersStore = defineStore('users', () => {
  const userRef = ref<CurrentUserApiResource | ManagerApiResource | GuestApiResource | VendorApiResource | null>(null);
  const accessTokenRef = ref<string | null>(readAccessToken());

  const user = computed(() => userRef.value);
  const accessToken = computed(() => accessTokenRef.value);

  const setUser = (newUser: CurrentUserApiResource | ManagerApiResource | GuestApiResource | VendorApiResource | null): void => {
    userRef.value = newUser;
  };
  const clearUser = (): void => {
    userRef.value = null;
  };

  const setAccessToken = (newAccessToken: string): void => {
    accessTokenRef.value = newAccessToken;
    writeAccessToken(newAccessToken);
  };
  const clearAccessToken = (): void => {
    accessTokenRef.value = null;
    writeAccessToken(null);
  };

  return {
    user,
    accessToken,

    setUser,
    clearUser,

    setAccessToken,
    clearAccessToken,
  };
});

export default useUsersStore;
